import { RetrievalQueries } from "@faire/deprecated-retailer-visitor-shared/features/RetrievalQueries/RetrievalQueries";
import { useSearchPageRequestId } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageRetrievalQueries } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRetrievalQueries";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React from "react";

export const SearchPageRetrievalQueries = () => {
  useTraceComponentRender("SearchPageRetrievalQueries");

  const requestId = useSearchPageRequestId();
  const allRetrievalQueries = useSearchPageRetrievalQueries();

  return (
    <RetrievalQueries
      allRetrievalQueries={allRetrievalQueries}
      requestId={requestId}
    />
  );
};
